import Vue from 'vue';
// import '../../view-specific/quote-results-base-v2';
import { QuoteResults } from '../../view-specific/quote-results-base-v2';

import {
    getItemSessionStorage,
    setItemSessionStorage
} from '../../helper-functions/services';

import {
    checkAgent,
    convertDateByLang
} from '../../helper-functions/helper-functions';


Vue.directive('resize', {
  inserted: function(el, binding) {
    const onResizeCallback = binding.value;
    window.addEventListener('resize', () => {
      const width = window.innerWidth;
      const height = document.documentElement.clientHeight;
      onResizeCallback({ width, height });
    });
  }
});


new Vue({
    el: '#app',
    components: {
        'quote-results-wrap': QuoteResults
    },
    // props:['ss-criteria'],
    data: {
        narrow: {
            planType: getItemSessionStorage('tabToView') == 'all' ? '' :
                      getItemSessionStorage('tabToView') == 'bestsellers' ? 3:
                      getItemSessionStorage('tabToView') == 'fixed' ? 1 : 2,
            ppoNetworkCheck: false,
            ppoNetwork: '',
            administrator: '',
            mailsInsuranceCard: false,
            extendable: false,
            refundable: false,
            acuteOnSetCondition: false,
            specificPlan: [],
            underwriter: '',
            coveragearea: '',
            instantVisaLetter: false,
            greenCardVisitor: false,
            covidCoverage: false,
            viewType: 1,
            viewSize: 1,
            covidQuarantine: getItemSessionStorage('quarantineCoverageCosta') && window.ibJS.section == "travelOutsideUSA" ? true : false,
            preExistingCondition: false,
            telemedicine: false
        },
        // planData: {
        //     fixedList: [],
        //     comprehensiveList: []
        // },
        headingsMap: {
            fixed: window.qResultsLang.fixed,
            comprehensive: window.qResultsLang.comprehensive
        },
        planTypesMap: {
            fixed:1,
            comprehensive:2,
            bestSeller:3
        },
        displayTabsList: {
          fixed: false,
          bestSeller: false,
          comprehensive: false,
          all: true
        },
        // sortBy: getItemSessionStorage('sort'+window.globalLanguage.section) ||  '',
        anyPlanBestseller: false,
        // isInternalIP: window.globalLanguage.internalIP,
        width: document.documentElement.clientWidth,
    },
    mounted: function() {
        checkAgent.call(this, [false]);     
    },
    methods: {
        extraPlanFilters: function(self, plans, ignorePlanTypeFilter = false) {
            if (self.narrow.acuteOnSetCondition) {
                plans = plans.filter((plan) => {
                    let isApplicable = false;
                    let planConfig = plan.planDetails.config;
                    if (planConfig.acuteOnsetPreExisting) {
                        let criteria = JSON.parse(getItemSessionStorage([window.globalLanguage.sectionCriteriaKey]));
                        if(criteria.travelerInfos?.length) {
                            isApplicable = true;
                            for (let i = 0; i < criteria.travelerInfos.length; i++) {
                                const travelerAge = criteria.travelerInfos[i].age;
                                if (travelerAge > planConfig.preExistingMaxAge || travelerAge < planConfig.preExistingMinAge) {
                                    isApplicable = false;
                                    break;
                                }
                            }
                        }
                    }
                    return isApplicable;
                });
            }

            if (self.narrow.ppoNetwork) {
                plans = plans.filter(function(plan) {
                    if (plan.planDetails.config.companyCode === 'WorldTrips' || plan.planDetails.config.companyCode === 'TIS') {
                        let criteria = JSON.parse(getItemSessionStorage([window.globalLanguage.sectionCriteriaKey]));
                        if (((criteria.citizenshipCountry && self.gdprCountries.indexOf(criteria.citizenshipCountry) != -1) ||
                                (criteria.homeCountry && self.gdprCountries.indexOf(criteria.homeCountry) != -1))) {
                            if (self.narrow.ppoNetwork === 'United Healthcare PPO') {
                                return false;
                            } else {
                                return plan.planDetails.usaPPOName;
                            }
                        } else {
                            if (self.narrow.ppoNetwork === 'First Health PPO') {
                                return false;
                            } else {
                                return plan.planDetails.usaPPOName;
                            }
                        }
                    } else {
                        return plan.planDetails.usaPPOName === self.narrow.ppoNetwork;
                    }
                });
            }

            if (!ignorePlanTypeFilter && self.narrow.planType) {

                if(self.narrow.planType=='1'){
                    if(getItemSessionStorage("storageSection") === self.section){
                        setItemSessionStorage("tabToView","fixed");
                        setItemSessionStorage("displayTabName","Fixed");
                    }
                    self.plansToView='fixed';
                    self.displaySelectedView='Fixed';
                }else if(self.narrow.planType=='2'){
                    if(getItemSessionStorage("storageSection") === self.section){
                        setItemSessionStorage("tabToView","comprehensive");
                        setItemSessionStorage("displayTabName","Comprehensive");
                    }
                    self.plansToView='comprehensive';
                    self.displaySelectedView='Comprehensive';
                }
                else if(self.narrow.planType=='3'){
                    if(getItemSessionStorage("storageSection") === self.section){
                        setItemSessionStorage("tabToView","bestsellers");
                        setItemSessionStorage("displayTabName","Best Sellers");
                    }
                    self.plansToView='bestsellers';
                    self.displaySelectedView='Best Sellers';
                }
            }
            //condition when the user selects all plans again on the narrow bar
            if(!ignorePlanTypeFilter && self.narrow.planType == ''){
                if(getItemSessionStorage("storageSection") === self.section){
                    setItemSessionStorage("tabToView","all");
                    setItemSessionStorage("displayTabName","All Plans");
                }
                self.plansToView='all';
                self.displaySelectedView='All Plans';
            }
            return plans;
        },
        setWidth: function(width) {
            this.width = width;
            setItemSessionStorage('width'+window.globalLanguage.section,width);
        },
        /**
         * In order to display how many items there is per tab (at all times), this method will call renderPlans and 
         * bypass some filters to get proper length Since using computed properties (list0Comp, list1Comp. etc..) will not be accurate.
         */
        getListLength() {
            const list0 = this.$refs.quoteResultsWrap.renderList(0, true) || [];
            const list1 = this.$refs.quoteResultsWrap.renderList(1, true) || [];
            const fixedPlans = [];
            const comprehensivePlans = [];

            if (list0) {
                list0.forEach(item => {
                    if (item.planDetails.config.planType === 2) {
                        comprehensivePlans.push(item);
                    } else {
                        fixedPlans.push(item);
                    }
                });
            }
            if (list1) {
                list1.forEach(item => {
                    if (item.planDetails.config.planType === 2) {
                        comprehensivePlans.push(item);
                    } else {
                        fixedPlans.push(item);
                    }
                });
            }

            const allPlans = [...fixedPlans, ...comprehensivePlans];
            const bestsellers = allPlans?.filter((plan) => {
                return plan.planDetails.config.bestseller === true;
            });

            return {
                fixedLength: fixedPlans?.length || 0,
                comprehensiveLength: comprehensivePlans?.length || 0,
                allPlansLength: allPlans?.length || 0,
                bestSellersLength: bestsellers?.length || 0,
            };
        },
        // sortByPriceL: function(planA, planB) {
        //     return (planA.defaultTotalPrice) - (planB.defaultTotalPrice);
        // },
        // setPlans:function(planData){
        //     this.planData.fixedList=planData.fixedList;
        //     this.planData.comprehensiveList=planData.comprehensiveList;
        // },
        // showNoPlansFoundError: function () {
        //     if (this.$children && this.$children.length && this.$children.length > 1 && typeof this.$children[1]?.showNoPlansFoundError === 'function') {
        //         this.$children[1].showNoPlansFoundError();
        //     } else if (this.$children && this.$children.length && this.$children.length == 1 && typeof this.$children[0]?.showNoPlansFoundError === 'function') {
        //         this.$children[0].showNoPlansFoundError();
        //     }
        // },
        // setBackendErrors: function setBackendErrors(errors) {
        //     if (errors.fieldErrors) {
        //         this.fieldErrors = errors.fieldErrors;
        //     }
        //     if (errors.globalErrors) {
        //         this.globalErrors = errors.globalErrors;
        //     }
        // },
        displayTabs: function(){

            var self2 = this;
            return function (){
            var self=this;
            var compTab= false;
            var list0=self.list0;

            // All this logic for the reason that visitors USA has fixed first and comprehensive next where as other travel medical has otherwise

            var section = window.globalLanguage.section;
            if(section == "visitorUSA"){
                if(list0.length > 0){
                    self2.displayTabsList.fixed = true;
                    for(var i=0;i<list0.length;i++){
                        if(list0[i].planDetails.config.bestseller){
                            self2.displayTabsList.bestSeller = true;
                            compTab = true;
                            break;
                        }
                    }
                }
            }
            else{
                if(list0.length > 0){
                    self2.displayTabsList.comprehensive = true;
                    for(var i=0;i<list0.length;i++){
                        if(list0[i].planDetails.config.bestseller){
                            self2.displayTabsList.bestSeller = true;
                            compTab = true;
                            break;
                        }
                    }
                }
            }

            var fixedTab= false;
            var list1=self.list1;
            if(section == "visitorUSA"){
                if(list1.length > 0){
                    self2.displayTabsList.comprehensive = true;
                    for(var i=0;i<list1.length;i++){
                        if(list1[i].planDetails.config.bestseller){
                            self2.displayTabsList.bestSeller = true;
                            fixedTab = true;
                            break;
                        }
                    }
                }
            }
            else{
                if(list1.length > 0){
                    self2.displayTabsList.fixed = true;
                    for(var i=0;i<list1.length;i++){
                        if(list1[i].planDetails.config.bestseller){
                            self2.displayTabsList.bestSeller = true;
                            fixedTab = true;
                            break;
                        }
                    }
                }
            }


            /*
            This logic also takes care of the condition when the narrow search options are selected so the tabs are reflected accordingly
                */



            // Handles display of sessionStorage to display plans
            var storageSection = getItemSessionStorage("storageSection");
            if(storageSection === self.section){
                self.plansToView = getItemSessionStorage("tabToView") ? getItemSessionStorage("tabToView")  : 'all';
            }else{
                self.plansToView = 'all';
            }

            // Handles display of sessionStorage mobile text
            if(storageSection === self.section){
                self.displaySelectedView = getItemSessionStorage("displayTabName") ? getItemSessionStorage("displayTabName")  : 'All Plans';
            }else{
                self.displaySelectedView =  'All Plans';
            }
            return true;
        }
      },
      initCriteria: function(self, responseBody) {
        if(responseBody.data.travelMedicalCriteria){
            self.policyMax = responseBody.data.travelMedicalCriteria.policyMaximum;
            if (typeof responseBody.data.travelMedicalCriteria.specificPlan == 'undefined') {
                // set specificPlan array for plan selection dropdown if not set
                responseBody.data.travelMedicalCriteria.specificPlan = [];
            }
            for(var key in self.narrow){
                if(typeof responseBody.data.travelMedicalCriteria[key] !='undefined'){
                    if (key == 'covidQuarantine' && !ibJS.retrievedQuotes) {
                        // leave as it is set on data quote results travel medical INSUBUY-6721
                    } else {
                        self.narrow[key] = responseBody.data.travelMedicalCriteria[key];
                        if(key != 'specificPlan' && (self.narrow[key] == null || self.narrow[key] == 0)){
                            self.narrow[key] = '';
                        }
                    }
                }
            }
            if(self.narrow.specificPlan == null){
                self.narrow.specificPlan = [];
            }
            self.ssCriteria = responseBody.data.travelMedicalCriteria;

            if(!window.sessionStorage[window.globalLanguage.sectionCriteriaKey]){
                window.sessionStorage[window.globalLanguage.sectionCriteriaKey] = JSON.stringify(self.ssCriteria);
            }
            if(window.globalLanguage.lang == 'zh'){
                convertDateByLang(self.ssCriteria,'zh');
            }else if(window.globalLanguage.lang == 'es'){
                convertDateByLang(self.ssCriteria,'es');
            }
        }
    },
    },
    created : function () {
        var self = this;
        var storageSection = getItemSessionStorage("storageSection");

        if(storageSection == null || storageSection == ""){
            setItemSessionStorage("storageSection",window.globalLanguage.section);

            if(getItemSessionStorage('tabToView') != null){
                self.narrow.planType =  getItemSessionStorage('tabToView') == 'all' ? '' :
                    getItemSessionStorage('tabToView') == 'bestsellers' ? 3:
                        getItemSessionStorage('tabToView') == 'fixed' ? 1 : 2;
            }
            else{

                // Don't need this logic now since the default will be all plans instead of best sellers

                // $.ajax({
                //     url: window.ibJS.fetchQuoteResultsAPIPath,
                //     data: {section: window.globalLanguage.section},
                //     type: "GET",
                //     async: false,
                //     success: function (response) {
                //         self.anyPlanBestseller =  response.data.anyPlanBestseller;
                //         if(self.anyPlanBestseller){
                //             self.narrow.planType = 3;
                //         }
                //         else{
                //             self.narrow.planType = '';
                //         }
                //     }
                // });

                self.narrow.planType = '';
            }
        }
    }  
});